// eslint-disable-next-line import/no-cycle
import UserSelectors from 'redux/user/user.selectors';
import { all, put, takeLatest } from 'redux-saga/effects';
// eslint-disable-next-line import/no-cycle
import apolloClient from 'services/graphql/config';
import {
  DELETE_NOTIFICATION as DELETE_MUTATION,
  UPDATE_NOTIFICATION as UPDATE_MUTATION,
} from 'services/graphql/mutations/notifications';
// eslint-disable-next-line import/no-cycle
import { store } from 'store';

import { StandardAction } from '../types';
import NotificationAction from './notification.action';
import { INotification, NotificationStatus } from './types';

const { READ_NOTIFICATION, READ_ALL, DELETE_NOTIFICATION, DELETE_ALL } = NotificationAction.ACTION_TYPES;

// eslint-disable-next-line require-yield
function* readNotification(action: StandardAction<INotification>) {
  const { payload: notification } = action;
  yield put(NotificationAction.toggleNotification());

  let variables = {};
  if (notification) {
    variables = {
      id: notification.id,
      receiver: notification.receiver,
      status: NotificationStatus.READ,
    };
  } else {
    const userId = UserSelectors.getUserId(store.getState());
    variables = {
      receiver: userId,
      status: NotificationStatus.READ,
    };
  }

  apolloClient
    .mutate({
      mutation: UPDATE_MUTATION,
      variables,
    })
    .catch((err) => {
      console.error(err);
    });
}

// eslint-disable-next-line require-yield
function* deleteNotification(action: StandardAction<INotification>) {
  const { payload: notification } = action;

  let variables;

  if (notification) {
    yield put(NotificationAction.toggleNotification());

    variables = {
      receiver: notification.receiver,
      id: notification.id,
    };
  } else {
    const user = UserSelectors.selectUser(store.getState());

    variables = {
      receiver: user.id,
    };
  }

  apolloClient
    .mutate({
      mutation: DELETE_MUTATION,
      variables,
    })
    .catch((err) => {
      console.error(err);
    });
}

export default function* () {
  yield all([
    takeLatest([READ_NOTIFICATION, READ_ALL], readNotification),
    takeLatest([DELETE_NOTIFICATION, DELETE_ALL], deleteNotification),
  ]);
}
